// Design tokens — Serviços / Produtos. Ref: .md/DESIGN_UIUX.md

export const CADASTRO_DESIGN = {
  root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',
  pageBody: 'pb-[120px]',
  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
  topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
  topbarIdentity: 'min-w-0 flex-1',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
  subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
  topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap md:pt-[5px]',
  sectionHeader: 'mt-[18px] first:mt-0',
  sectionHeaderTitle: 'text-[13px] font-bold uppercase tracking-[0.06em] text-[#a1a1aa]',
  sectionHeaderSub: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5]',
  stack: 'flex flex-col gap-3.5',
  cardFlush: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0',
  primaryButton:
    'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9]',
  ghostButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButton:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButtonDanger:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#b42318] hover:bg-[#fef3f2] hover:border-[#fecdca]',
  link: 'text-[13px] font-semibold text-[#6d28d9] hover:text-[#5b21b6] hover:underline',
  badge: 'inline-flex items-center gap-1.5 px-2.5 py-[3px] rounded-md text-[12px] font-semibold border',
  badgeNeutral: 'bg-[#f4f4f5] text-[#71717a] border-[#e7e7ec]',
  badgeSoft: 'bg-[#ede9fe] text-[#5b21b6] border-[#ddd6fe]',
  tableHead: 'text-[12px] font-semibold uppercase tracking-[0.04em] text-[#a1a1aa] bg-[#fafafb]',
  tableRow: 'border-b border-[#f0f0f3] last:border-b-0 hover:bg-[#fafafb]',
  emptyWrap: 'px-2 py-10 text-center',
  emptyIcon: 'mx-auto mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa]',
  emptyTitle: 'text-[15px] font-semibold text-[#18181b]',
  emptyDesc: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5] max-w-sm mx-auto',
  switch: 'data-[state=checked]:bg-[#6d28d9] data-[state=unchecked]:bg-[#d4d4d8]',
};

export default CADASTRO_DESIGN;
